module.exports = __webpack_public_path__ + "static/media/Orpyx-SI-Logo-Knockout.0ec93252.png";